import { isElementTypeContainer } from '@/common/converter/utils/element'

/**
 * element list 에서 SubType 을 반환
 * @param elementList
 * @returns {string} 'editor_pick_list' | 'general_list'
 */
export const getSubType = (elementList) => {
  const element = elementList?.find(isElementTypeContainer) ?? {}
  const { contextProperty } = element

  return contextProperty?.top?.likeStatus ? 'editor_pick_list' : 'general_list'
}
